<template>
  <div class="container" id="chart">
    <div class="title">
      <v-row>
        <v-col cols="4" class="text-left">
          <span>ยอดขายของเดือน {{ getMonthFromYearMonth(selectedYearMonth)  }}</span>
          <div class="tooltip">
            <v-icon dark left color="#707070" size="20px" style="margin-left: 10px" >mdi-information-outline</v-icon>
            <span class="tooltiptext">ยอดขายไม่รวมภาษี</span>
          </div>
          <div class="tw-text-4xl tw-text-light-green tw-font-bold tw-pt-2">{{ (summaryMonth.salesAmount /100).toLocaleString()}}  ฿</div>

          <v-row v-if="selectShowGraphIndex" class="text-left" style="justify-content: flex-start;">
            <v-col style="max-width: 189px; max-height: 87px">
              <v-icon dark left color="#6ec39b">mdi-circle</v-icon>
              {{ getMonthFromYearMonth(selectedYearMonth) }}
              <div>
                <v-icon dark left color="#c84f99">mdi-circle</v-icon>
                {{ getPreviousMonth(selectedYearMonth) }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="8" class="text-right">

          <span class="box-btn">
            <v-btn text :class="selectedDayOrWeek === 'day' ? 'activeSwitch left' : 'not-selected left'" @click="onChangeSelectedDayOrWeek('day')" style="height: 36px; width: 98px">รายวัน</v-btn>
            <v-btn text :class="selectedDayOrWeek === 'week' ? 'activeSwitch right' : 'not-selected right'" @click="onChangeSelectedDayOrWeek('week')" style="height: 36px; width: 98px">รายสัปดาห์</v-btn>
          </span>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <span class="box-btn" style="max-width: 176px">
                <v-btn color=#6ec39b depressed style="border-radius: 8px; width: 36px; margin-left: -3px; margin-top: -2px;" @click="getLastMonth(date)">
                <v-icon color=#ffffff>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                color="#ffffff"
                width="150px"
                height="30px"
                style="justify-content: center; box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0); font-size: 16px;"
                v-model="date"
                readonly
                v-bind="attrs"
                v-on="on">
                <div>
                  <span>{{ getMontFromCalender(date) }}</span>
                </div>
              </v-btn>
              <v-btn color=#6ec39b depressed style="border-radius: 8px; width: 36px; margin-right: -3px; margin-top: -2px;" @click="getNextMonth(date)">
                <v-icon color=#ffffff>mdi-chevron-right</v-icon>
              </v-btn>
              </span>
            </template>
            <v-date-picker
              v-model="date"
              type="month"
              locale="th"
              no-title
              scrollable
              style="color: #191919"
            >
              <v-spacer></v-spacer>
              <v-btn text color="#b3b3b3" @click="menu = false">ยกเลิก</v-btn>
              <v-btn text color="#6ec39b" @click="setSelectDate(date)">ตกลง</v-btn>
            </v-date-picker>
          </v-menu>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#ffffff"
                width="220px"
                height="40px"
                v-bind="attrs"
                v-on="on"
                class="dropdown"
              >
                <div>
                  {{ items[selectShowGraphIndex] }}
                </div>
                <img src="/images/icon-angle-down.svg" style="max-width: 14px; max-height: 14px; margin-left: 10px" alt="dropdown" />
              </v-btn>
            </template>
            <v-list>
              <v-list-item-group
                v-model="selectShowGraphIndex"
                color="#6ec39b"
                mandatory
              >
                <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                  link
                >
                  <v-list-item-title class="text-center">{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </div>
    <line-chart
      v-if="loaded"
      :chartData="selectedDayOrWeek === 'day' ? chartDayData : chartData"
      :options="options"/>
  </div>
</template>

<script>
import LineChart from './line-boundaries.vue'
import {mapState} from "vuex";
import moment from 'moment';
import 'moment/locale/th'

moment.locale('th')

export default {
  name: 'LineChartContainer',
  computed: mapState({
    selectedCompany: state => state.companies.selectedCompany,
    summaryList: state => state.summariesByCompany.summaryList,
    selectedSummaryDate: state => state.summariesByCompany.selectedSummaryDate,
    selectedYearMonth: state => state.summariesByCompany.selectedYearMonth,
    summaryMonth: state => state.summariesByCompany.summaryMonth,
    chartData: state => state.summariesByCompany.chartData,
    chartDayData: state => state.summariesByCompany.chartDayData,
    selectedDayOrWeek: state => state.summariesByCompany.selectedDayOrWeek
  }),
  created() {
    let selectedYearMonth = moment().format('YYYY-MM')
    this.dispatchSelectedYearMonth(selectedYearMonth)
    if (this.$route.params.companyId) {
      this.queryGraph(selectedYearMonth)
    }
  },
  beforeDestroy() {
    this.clearSubscript();
  },
  methods: {
    clearSubscript: function(){
      this.$store.dispatch('summariesByCompany/getSummaryMonthUnsubscribe')
      this.$store.dispatch('summariesByCompany/getSummaryDayFirstUnsubscribe')
      this.$store.dispatch('summariesByCompany/getSummaryDaySecondUnsubscribe')
    },
    setSelectDate: function (selectedYearMonth) {
      this.$refs.menu.save(selectedYearMonth)
      this.dispatchSelectedYearMonth(selectedYearMonth)
      this.queryGraph(selectedYearMonth)
    },
    getMonth: function (n) {
      return moment(n, 'MM').format('MMMM')
    },
    getMonthFromYearMonth: function (selectedYearMonth) {
      return moment(selectedYearMonth, "YYYY-MM").format('MMMM')
    },
    getPreviousMonth: function (selectedYearMonth) {
      return moment(selectedYearMonth, "YYYY-MM").subtract(1, 'months').format('MMMM')
    },
    getMontFromCalender: function (date) {
      return moment(date, "YYYY-MM").add(543, 'year').format('MMMM YYYY')
    },
    getNextMonth: function (date) {
      let targetDate = moment(date, "YYYY-MM").add(1, 'months').format('YYYY-MM')
      this.date = targetDate
      this.setSelectDate(targetDate)
    },
    getLastMonth: function (date) {
      let targetDate = moment(date, "YYYY-MM").subtract(1, 'months').format('YYYY-MM')
      this.date = targetDate
      this.setSelectDate(targetDate)
    },
    dispatchGetSummaryDateInMount: function (selectedYearMonth) {
      let companyId = this.$route.params.companyId
      this.$store.dispatch('summariesByCompany/getSummaryDateInMount', {
        companyId,
        selectedYearMonth: selectedYearMonth,
        checked: this.selectShowGraphIndex
      })
    },
    queryGraph: function (selectedYearMonth) {
      let companyId = this.$route.params.companyId
      this.clearSubscript();
      this.$store.dispatch('summariesByCompany/getSummaryMonth', {companyId, selectedYearMonth})
      this.dispatchGetSummaryDateInMount(selectedYearMonth)
    },
    dispatchSelectedYearMonth: function (selectedYearMonth) {
      this.$store.dispatch('summariesByCompany/setSelectedYearMonth', {selectedYearMonth})
    },
    onChangeSelectedDayOrWeek: function (selected) {
      this.$store.dispatch('summariesByCompany/setSelectedDayOrWeek', {selected})
    }
  },
  components: {LineChart},
  data: () => ({
    loaded: false,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      duration: 20000,
      layout: {
        padding: {
          left: 10,
          right: 10,
          top: 30,
          bottom: 10
        }
      },
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return value.toLocaleString();
          },

        } // end callbacks:
      },
      spanGaps: false,
      animation: {
        duration: 2000 // general animation time
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false,
          },
          ticks: {
            fontSize: 15,
            fontColor: 'lightgrey'
          }
        }],
        yAxes: [{
          gridLines: {
            display: false,
          },
          ticks: {
            beginAtZero: true,
            fontSize: 15,
            fontColor: 'lightgrey',
            maxTicksLimit: 5,
            padding: 25,
            userCallback: function(value) {
              return value.toLocaleString();
            }
          }
        }]
      }
    },
    date: new Date().toISOString().substr(0, 7),
    menu: false,
    modal: false,
    show: false,
    items: [
      'แสดงกราฟเดือนเดียว',
      'เปรียบเทียบเดือนก่อน'
    ],
    selectShowGraphIndex: 0,
  }),

  async mounted() {
    this.loaded = true
  },
  watch: {
    selectShowGraphIndex: {
      handler: function (val){
        if (val){
          this.dispatchGetSummaryDateInMount(this.selectedYearMonth)
        } else {
          this.dispatchGetSummaryDateInMount(this.selectedYearMonth)
        }
      }
    },
    selectedDayOrWeek: {
      handler: function (val){
        if (val){
          this.dispatchGetSummaryDateInMount(this.selectedYearMonth)
        } else {
          this.dispatchGetSummaryDateInMount(this.selectedYearMonth)
        }
      }
    }
  }
}

</script>

<style lang="scss">
#chart {
  .title {
    font-size: 16px;
    padding: 10px 15px;

    .total {
      font-size: 30px;
      font-weight: bold;
      color: #6ec39b;
      padding-top: 10px;
    }
  }

  .box-btn {
    border: 1px solid #c4c4c4;
    border-radius: 10px;
    padding: 3px;
    margin-right: 10px;
  }

  .activeSwitch {
    color: #ffffff !important;
    background-color: #6ec39b !important;
    border-radius: 8px !important;
    font-size: 16px;
    margin-top: -2px;

    &.left {
      margin-left: -3px;
    }
    &.right {
      margin-right: -3px;
    }
  }

  .not-selected {
    color: #707070;
    font-size: 16px;
  }

  .v-application .primary--text {
    color: #707070 !important;
  }
  .v-application .accent--text {
    color: #707070 !important;
  }

  .nextMonth {
    color: #6ec39b;
    max-width: 36px;
    max-height: 36px;
  }

  .v-btn:before {
    background-color: #FFFFFF !important;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    padding: 16px;
    min-width: 0px;
  }
  .v-btn{
    flex-direction: column;
    align-items: center;
  }
  .dropdown{
    border: solid 1px #c4c4c4 !important;
    border-radius: 10px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0);
    font-size: 16px;
    //display: flex;
  }

}
.v-application .accent {
  background-color: #51cc77 !important;
  border-color: #51cc77 !important;
}
.tooltip {
  position: relative;
  display: inline-block;
  //border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 175px;
  height: 40px;
  background-color: #c4c4c4;
  font-size: 16px;
  color: #191919;
  text-align: left;
  border-bottom-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 5px 10px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 105%;
  opacity: 0;
  transition: opacity 2s;

}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>
